import OrderDelivery from 'modules/userModule/screens/OrderDeliveryPage';

export default OrderDelivery;
